if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        queueMicrotask(() => {
          this.querySelectorAll('details[open]').forEach((details) => {
            const summary = details.querySelector(':scope > summary');
            if (summary && /^details\s*:?$/i.test(summary.textContent.trim())) {
              details.removeAttribute('open');
            }
          });
        });
      }
    }
  );
}
